/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ButtonPrimary, ButtonSecondary, ButtonTertiary } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';
import AdvSaveSearch from './AdvSaveSearch';

const AdvFormActionButtons = ({
  leftButtonName,
  rightButtonName,
  handleFormLeftButton,
  handleFormRightButton = null,
  isSearchDisabled,
  form,
  pageData,
  setPageData,
  enableSaveSearch,
  savedSearchList,
  showPopup,
  setShowPopup,
  onItemClick,
  handleFormReset,
  selectedItem,
  setSelectedItem,
}) => (
  <div css={advFormStyles['.formBtnContainer']} className="col-md-12">
    <ButtonTertiary
      type="reset"
      aria-label="Reset"
      id="AdvFormActionButtons-reset-form"
      className="col-md-1 margin-responsive-r"
      onClick={() => handleFormLeftButton(form)}
    >
      {leftButtonName}
    </ButtonTertiary>
    {enableSaveSearch
      && (
      <AdvSaveSearch
        pageData={pageData}
        setPageData={setPageData}
        savedSearchList={savedSearchList}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        onItemClick={onItemClick}
        handleFormReset={handleFormReset}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    )}
    <ButtonPrimary
      type="button"
      aria-label="Search"
      id="AdvFormActionButtons-submit-form"
      className="col-md-1"
      onClick={handleFormRightButton}
      disabled={isSearchDisabled}
    >
      {rightButtonName}
    </ButtonPrimary>
  </div>
);

AdvFormActionButtons.displayName = 'AdvFormActionButtons';

AdvFormActionButtons.propTypes = {
  handleFormLeftButton: PropTypes.func.isRequired,
  handleFormRightButton: PropTypes.func.isRequired,
  isSearchDisabled: PropTypes.bool,
  leftButtonName: PropTypes.string,
  rightButtonName: PropTypes.string,
  form: PropTypes.shape({}),
};

export default AdvFormActionButtons;
